import s from "./searchBackdrop.module.css";
import {h} from "preact";
import {useBehavioralContext} from "../../../../contexts";

const SearchBackdrop = ({ hasPromoBanner }) => {
    // Funcional data
    const {
        searchBarData,
        handleSearchBar
    } = useBehavioralContext();

    return (
        <div
            className={`${s.backdrop} ${searchBarData["isOpen"] && s.openBackdrop} ${hasPromoBanner ? s.backdropWithPromo : ""}`}
            onClick={() => handleSearchBar("isOpen", !searchBarData["isOpen"])}
            data-testid="header-search-backdrop"
        />
    )
}

export default SearchBackdrop;
